import { supabase } from '@/lib/supabase';

interface LeadData {
  source: 'contact_form' | 'request_quote';
  product?: string;
  company: string;
  country: string;
  phone: string;
  email: string;
  message: string;
}

export const leadService = {
  /**
   * Quietly logs lead to Supabase - NEVER throws errors to prevent form submission blocking
   */
  async logLead(data: LeadData): Promise<void> {
    try {
      const { error } = await supabase
        .from('leads')
        .insert({
          source: data.source,
          product: data.product || null,
          company: data.company,
          country: data.country,
          phone: data.phone,
          email: data.email,
          message: data.message,
        });

      if (error) {
        // Silent logging - never expose errors to users
        console.log('Lead logging info:', {
          status: 'failed',
          reason: error.message,
          source: data.source
        });
      }
    } catch (error: any) {
      // Silent catch - infrastructure issues should never block submissions
      console.log('Lead storage unavailable:', {
        status: 'skipped',
        source: data.source
      });
    }
  },

  async getAllLeads() {
    const { data, error } = await supabase
      .from('leads')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      throw new Error(error.message);
    }

    return data || [];
  }
};